/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EventsIcon = createIcon("EventsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 3v17a2 2 0 01-2 2H3a2 2 0 01-2-2V3a1 1 0 011-1h20a1 1 0 011 1ZM7 5.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2Zm10 0a1.001 1.001 0 010-2 1.001 1.001 0 010 2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2a1 1 0 00-1 1v4h22V3a1 1 0 00-1-1ZM7 5.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2Zm10 0a1.001 1.001 0 010-2 1.001 1.001 0 010 2Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h2v2H3v-2Zm0 4h2v2H3v-2Zm4-8h2v2H7V9Zm0 4h2v2H7v-2Zm0 4h2v2H7v-2Zm4-8h2v2h-2V9Zm0 4h2v2h-2v-2Zm0 4h2v2h-2v-2Zm4-8h2v2h-2V9Zm0 4h2v2h-2v-2Zm0 4h2v2h-2v-2Zm4-8h2v2h-2V9Zm0 4h2v2h-2v-2Z",
    fill: "gray"
  })));
}, {});